import { scanSplitApi as api } from "./apiBase";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        cohortControllerRetrieveCohorts: build.query<
            CohortControllerRetrieveCohortsApiResponse,
            CohortControllerRetrieveCohortsApiArg
        >({
            query: (queryArg) => ({
                url: `/cohorts`,
                params: {
                    MerchantId: queryArg.merchantId,
                    Page: queryArg.page,
                    PageSize: queryArg.pageSize,
                },
            }),
        }),
        cohortControllerCreateCohort: build.mutation<
            CohortControllerCreateCohortApiResponse,
            CohortControllerCreateCohortApiArg
        >({
            query: (queryArg) => ({
                url: `/cohorts`,
                method: "POST",
                body: queryArg.createCohortCommand,
            }),
        }),
        cohortControllerRetrieveCohort: build.query<
            CohortControllerRetrieveCohortApiResponse,
            CohortControllerRetrieveCohortApiArg
        >({
            query: (queryArg) => ({
                url: `/cohorts/${queryArg.cohortId}`,
                params: { merchantId: queryArg.merchantId },
            }),
        }),
        cohortControllerUpdateCohort: build.mutation<
            CohortControllerUpdateCohortApiResponse,
            CohortControllerUpdateCohortApiArg
        >({
            query: (queryArg) => ({
                url: `/cohorts/${queryArg.cohortId}`,
                method: "PUT",
                body: queryArg.updateCohortCommand,
            }),
        }),
        cohortControllerRemoveCohort: build.mutation<
            CohortControllerRemoveCohortApiResponse,
            CohortControllerRemoveCohortApiArg
        >({
            query: (queryArg) => ({
                url: `/cohorts/${queryArg.cohortId}`,
                method: "DELETE",
                params: { merchantId: queryArg.merchantId },
            }),
        }),
        cohortControllerRetrieveCohortMember: build.query<
            CohortControllerRetrieveCohortMemberApiResponse,
            CohortControllerRetrieveCohortMemberApiArg
        >({
            query: (queryArg) => ({
                url: `/cohorts/members/${queryArg.cohortMemberId}`,
                params: { merchantId: queryArg.merchantId },
            }),
        }),
        cohortControllerAddCohortMembers: build.mutation<
            CohortControllerAddCohortMembersApiResponse,
            CohortControllerAddCohortMembersApiArg
        >({
            query: (queryArg) => ({
                url: `/cohorts/${queryArg.cohortId}/members`,
                method: "POST",
                body: queryArg.addCohortMembersCommand,
            }),
        }),
        cohortControllerRemoveCohortMember: build.mutation<
            CohortControllerRemoveCohortMemberApiResponse,
            CohortControllerRemoveCohortMemberApiArg
        >({
            query: (queryArg) => ({
                url: `/cohorts/${queryArg.cohortId}/members/${queryArg.memberId}`,
                method: "DELETE",
                params: { merchantId: queryArg.merchantId },
            }),
        }),
        devicesControllerCreateFootMeasurements: build.mutation<
            DevicesControllerCreateFootMeasurementsApiResponse,
            DevicesControllerCreateFootMeasurementsApiArg
        >({
            query: (queryArg) => ({
                url: `/scans/${queryArg.clientReference}/foot-measurements`,
                method: "POST",
                body: queryArg.footMeasurements,
            }),
        }),
        measurementsControllerRetrieveScanMeasurements: build.query<
            MeasurementsControllerRetrieveScanMeasurementsApiResponse,
            MeasurementsControllerRetrieveScanMeasurementsApiArg
        >({
            query: (queryArg) => ({
                url: `/scans/${queryArg.scanId}/measurements`,
            }),
        }),
        measurementsControllerRetrieveSessionMeasurements: build.query<
            MeasurementsControllerRetrieveSessionMeasurementsApiResponse,
            MeasurementsControllerRetrieveSessionMeasurementsApiArg
        >({
            query: (queryArg) => ({
                url: `/scans/${queryArg.sessionId}/measurements`,
            }),
        }),
        measurementsControllerRetrieveMeasurementsCsv: build.query<
            MeasurementsControllerRetrieveMeasurementsCsvApiResponse,
            MeasurementsControllerRetrieveMeasurementsCsvApiArg
        >({
            query: (queryArg) => ({ url: `/scans/${queryArg.sessionId}/csv` }),
        }),
        measurementsControllerRetrieveAllMeasurements: build.query<
            MeasurementsControllerRetrieveAllMeasurementsApiResponse,
            MeasurementsControllerRetrieveAllMeasurementsApiArg
        >({
            query: (queryArg) => ({
                url: `/scans/${queryArg.scanId}/all-measurements`,
            }),
        }),
        measurementsControllerRetrieveMeasurementAmendments: build.query<
            MeasurementsControllerRetrieveMeasurementAmendmentsApiResponse,
            MeasurementsControllerRetrieveMeasurementAmendmentsApiArg
        >({
            query: (queryArg) => ({
                url: `/scans/${queryArg.scanId}/measurements/${queryArg.measurementsId}/amendments`,
            }),
        }),
        measurementsControllerUpdateScanMeasurement: build.mutation<
            MeasurementsControllerUpdateScanMeasurementApiResponse,
            MeasurementsControllerUpdateScanMeasurementApiArg
        >({
            query: (queryArg) => ({
                url: `/scans/${queryArg.scanId}/measurements/${queryArg.measurementsId}/${queryArg.measurementKey}`,
                method: "PUT",
                body: queryArg.measurementAmendmentDto,
            }),
        }),
        measurementsControllerUpdateWaistMeasurement: build.mutation<
            MeasurementsControllerUpdateWaistMeasurementApiResponse,
            MeasurementsControllerUpdateWaistMeasurementApiArg
        >({
            query: (queryArg) => ({
                url: `/scans/${queryArg.scanId}/measurements/${queryArg.measurementsId}/waist`,
                method: "POST",
                body: queryArg.waistMeasurementAmendmentDto,
            }),
        }),
        reportsControllerRetrieveScanQualityReport: build.query<
            ReportsControllerRetrieveScanQualityReportApiResponse,
            ReportsControllerRetrieveScanQualityReportApiArg
        >({
            query: (queryArg) => ({
                url: `/reports/scan-quality-report`,
                params: {
                    From: queryArg["from"],
                    To: queryArg.to,
                    MerchantId: queryArg.merchantId,
                },
            }),
        }),
        reportsControllerRetrieveMeasurementQualityReport: build.query<
            ReportsControllerRetrieveMeasurementQualityReportApiResponse,
            ReportsControllerRetrieveMeasurementQualityReportApiArg
        >({
            query: (queryArg) => ({
                url: `/reports/measurement-quality-report`,
                params: {
                    From: queryArg["from"],
                    To: queryArg.to,
                    MerchantId: queryArg.merchantId,
                },
            }),
        }),
        reportsControllerRetrieveSizeMatchAccuracyReport: build.query<
            ReportsControllerRetrieveSizeMatchAccuracyReportApiResponse,
            ReportsControllerRetrieveSizeMatchAccuracyReportApiArg
        >({
            query: (queryArg) => ({
                url: `/reports/sizematch-accuracy-report`,
                params: {
                    MerchantId: queryArg.merchantId,
                    ProductCode: queryArg.productCode,
                    From: queryArg["from"],
                    To: queryArg.to,
                },
            }),
        }),
        reportsControllerRetrieveScannerUsageReport: build.query<
            ReportsControllerRetrieveScannerUsageReportApiResponse,
            ReportsControllerRetrieveScannerUsageReportApiArg
        >({
            query: (queryArg) => ({
                url: `/reports/scanner-usage-report`,
                params: {
                    Month: queryArg.month,
                    MerchantId: queryArg.merchantId,
                },
            }),
        }),
        scanControllerRetrieveScans: build.query<
            ScanControllerRetrieveScansApiResponse,
            ScanControllerRetrieveScansApiArg
        >({
            query: (queryArg) => ({
                url: `/scans`,
                params: {
                    MerchantId: queryArg.merchantId,
                    Page: queryArg.page,
                    PageSize: queryArg.pageSize,
                    DeviceId: queryArg.deviceId,
                },
            }),
        }),
        scanControllerRetrieveScan: build.query<
            ScanControllerRetrieveScanApiResponse,
            ScanControllerRetrieveScanApiArg
        >({
            query: (queryArg) => ({ url: `/scans/${queryArg.scanId}` }),
        }),
        scanControllerRetrieveWellnessMeasurements: build.query<
            ScanControllerRetrieveWellnessMeasurementsApiResponse,
            ScanControllerRetrieveWellnessMeasurementsApiArg
        >({
            query: (queryArg) => ({
                url: `/scans/${queryArg.scanId}/wellness`,
            }),
        }),
        scanControllerSubmitQualityReport: build.mutation<
            ScanControllerSubmitQualityReportApiResponse,
            ScanControllerSubmitQualityReportApiArg
        >({
            query: (queryArg) => ({
                url: `/scans/${queryArg.scanId}/quality-report`,
                method: "PUT",
                body: queryArg.scanQualityReportDto,
            }),
        }),
        scanControllerRetrieveDownloadUrl: build.query<
            ScanControllerRetrieveDownloadUrlApiResponse,
            ScanControllerRetrieveDownloadUrlApiArg
        >({
            query: (queryArg) => ({
                url: `/scans/${queryArg.scanId}/raw-download`,
            }),
        }),
        scanControllerRetrieveObjDownload: build.query<
            ScanControllerRetrieveObjDownloadApiResponse,
            ScanControllerRetrieveObjDownloadApiArg
        >({
            query: (queryArg) => ({
                url: `/scans/${queryArg.scanId}/obj-download`,
            }),
        }),
        scanControllerRequestIntegration: build.mutation<
            ScanControllerRequestIntegrationApiResponse,
            ScanControllerRequestIntegrationApiArg
        >({
            query: (queryArg) => ({
                url: `/scans/${queryArg.scanId}/integrations`,
                method: "POST",
                params: { integrationDetails: queryArg.integrationDetails },
            }),
        }),
        scanControllerRetrieveScanSessionTitle: build.query<
            ScanControllerRetrieveScanSessionTitleApiResponse,
            ScanControllerRetrieveScanSessionTitleApiArg
        >({
            query: (queryArg) => ({ url: `/scans/${queryArg.scanId}/title` }),
        }),
        sessionsControllerRetrieveSessions: build.query<
            SessionsControllerRetrieveSessionsApiResponse,
            SessionsControllerRetrieveSessionsApiArg
        >({
            query: (queryArg) => ({
                url: `/sessions`,
                params: {
                    MerchantId: queryArg.merchantId,
                    Page: queryArg.page,
                    DeviceId: queryArg.deviceId,
                    Title: queryArg.title,
                    ScanId: queryArg.scanId,
                    From: queryArg["from"],
                    To: queryArg.to,
                    QaPending: queryArg.qaPending,
                    SessionTags: queryArg.sessionTags,
                },
            }),
        }),
        sessionsControllerRetrieveSession: build.query<
            SessionsControllerRetrieveSessionApiResponse,
            SessionsControllerRetrieveSessionApiArg
        >({
            query: (queryArg) => ({ url: `/sessions/${queryArg.id}` }),
        }),
        sessionsControllerRetrieveSessionStatus: build.query<
            SessionsControllerRetrieveSessionStatusApiResponse,
            SessionsControllerRetrieveSessionStatusApiArg
        >({
            query: (queryArg) => ({ url: `/sessions/${queryArg.id}/status` }),
        }),
        sessionsControllerRetrieveDiagnosticsUrl: build.query<
            SessionsControllerRetrieveDiagnosticsUrlApiResponse,
            SessionsControllerRetrieveDiagnosticsUrlApiArg
        >({
            query: (queryArg) => ({
                url: `/sessions/${queryArg.id}/diagnostics`,
            }),
        }),
        sessionsControllerRetrieveAuditHistory: build.query<
            SessionsControllerRetrieveAuditHistoryApiResponse,
            SessionsControllerRetrieveAuditHistoryApiArg
        >({
            query: (queryArg) => ({
                url: `/sessions/${queryArg.id}/audit-items/${queryArg.page}`,
            }),
        }),
        sessionsControllerRetrieveSessionDataByClientReference: build.query<
            SessionsControllerRetrieveSessionDataByClientReferenceApiResponse,
            SessionsControllerRetrieveSessionDataByClientReferenceApiArg
        >({
            query: (queryArg) => ({
                url: `/sessions/${queryArg.clientReference}/data`,
                params: {
                    isInternalRequest: queryArg.isInternalRequest,
                    warnOnSessionNotFound: queryArg.warnOnSessionNotFound,
                },
            }),
        }),
        sessionsControllerSubscribeSession: build.mutation<
            SessionsControllerSubscribeSessionApiResponse,
            SessionsControllerSubscribeSessionApiArg
        >({
            query: (queryArg) => ({
                url: `/sessions/${queryArg.clientReference}/subscriptions`,
                method: "POST",
                body: queryArg.subscribeSessionRequest,
            }),
        }),
        sessionsControllerRetrieveSessionTags: build.query<
            SessionsControllerRetrieveSessionTagsApiResponse,
            SessionsControllerRetrieveSessionTagsApiArg
        >({
            query: (queryArg) => ({
                url: `/sessions/tags`,
                params: { sessionId: queryArg.sessionId },
            }),
        }),
        sessionsControllerUpdateSessionTags: build.mutation<
            SessionsControllerUpdateSessionTagsApiResponse,
            SessionsControllerUpdateSessionTagsApiArg
        >({
            query: (queryArg) => ({
                url: `/sessions/${queryArg.sessionId}/tags`,
                method: "PUT",
                body: queryArg.body,
            }),
        }),
        sessionsControllerRetrieveSessionExtractionResult: build.query<
            SessionsControllerRetrieveSessionExtractionResultApiResponse,
            SessionsControllerRetrieveSessionExtractionResultApiArg
        >({
            query: (queryArg) => ({
                url: `/sessions/${queryArg.sessionId}/extraction-results`,
            }),
        }),
        sessionsControllerRetrieveSessionMeasurementAssets: build.query<
            SessionsControllerRetrieveSessionMeasurementAssetsApiResponse,
            SessionsControllerRetrieveSessionMeasurementAssetsApiArg
        >({
            query: (queryArg) => ({
                url: `/sessions/${queryArg.sessionId}/measurement-assets`,
            }),
        }),
        sessionsControllerDeleteSession: build.mutation<
            SessionsControllerDeleteSessionApiResponse,
            SessionsControllerDeleteSessionApiArg
        >({
            query: (queryArg) => ({
                url: `/sessions/${queryArg.merchantId}/${queryArg.sessionId}`,
                method: "DELETE",
            }),
        }),
        sizeMatchControllerRetrieveScanSizeMatchRecommendations: build.query<
            SizeMatchControllerRetrieveScanSizeMatchRecommendationsApiResponse,
            SizeMatchControllerRetrieveScanSizeMatchRecommendationsApiArg
        >({
            query: (queryArg) => ({
                url: `/size-match/${queryArg.merchantId}/scans/${queryArg.scanId}`,
                params: {
                    ProductCode: queryArg.productCode,
                    Page: queryArg.page,
                    PageSize: queryArg.pageSize,
                },
            }),
        }),
        sizeMatchControllerRetrieveSessionSizeMatchRecommendations: build.query<
            SizeMatchControllerRetrieveSessionSizeMatchRecommendationsApiResponse,
            SizeMatchControllerRetrieveSessionSizeMatchRecommendationsApiArg
        >({
            query: (queryArg) => ({
                url: `/size-match/${queryArg.merchantId}/scans/${queryArg.sessionId}`,
                params: {
                    ProductCode: queryArg.productCode,
                    Page: queryArg.page,
                    PageSize: queryArg.pageSize,
                },
            }),
        }),
        sizeMatchControllerRetrieveSizeMatchRecommendationsCsv: build.query<
            SizeMatchControllerRetrieveSizeMatchRecommendationsCsvApiResponse,
            SizeMatchControllerRetrieveSizeMatchRecommendationsCsvApiArg
        >({
            query: (queryArg) => ({
                url: `/size-match/${queryArg.merchantId}/scans/${queryArg.sessionId}/csv`,
                params: {
                    productCode: queryArg.productCode,
                    productName: queryArg.productName,
                    fit: queryArg.fit,
                    categoryTags: queryArg.categoryTags,
                },
            }),
        }),
        sizeMatchControllerRetrieveProductSizeMatchRecommendations: build.query<
            SizeMatchControllerRetrieveProductSizeMatchRecommendationsApiResponse,
            SizeMatchControllerRetrieveProductSizeMatchRecommendationsApiArg
        >({
            query: (queryArg) => ({
                url: `/size-match/${queryArg.merchantId}/products/${queryArg.productCode}`,
                params: { from: queryArg["from"], pageSize: queryArg.pageSize },
            }),
        }),
        sizeMatchControllerDeleteSizeMatchResult: build.mutation<
            SizeMatchControllerDeleteSizeMatchResultApiResponse,
            SizeMatchControllerDeleteSizeMatchResultApiArg
        >({
            query: (queryArg) => ({
                url: `/size-match/${queryArg.merchantId}/scans/${queryArg.scanId}/${queryArg.resultId}`,
                method: "DELETE",
            }),
        }),
        sizeMatchControllerAddOrUpdateSizeMatchReport: build.mutation<
            SizeMatchControllerAddOrUpdateSizeMatchReportApiResponse,
            SizeMatchControllerAddOrUpdateSizeMatchReportApiArg
        >({
            query: (queryArg) => ({
                url: `/size-match/${queryArg.merchantId}/scans/${queryArg.scanId}/${queryArg.resultId}/report`,
                method: "PUT",
                body: queryArg.sizeMatchReportDto,
            }),
        }),
        sizeMatchControllerRetrieveSizeMatchRecommendations: build.query<
            SizeMatchControllerRetrieveSizeMatchRecommendationsApiResponse,
            SizeMatchControllerRetrieveSizeMatchRecommendationsApiArg
        >({
            query: (queryArg) => ({
                url: `/size-match`,
                params: {
                    MerchantId: queryArg.merchantId,
                    ScanId: queryArg.scanId,
                    ScanTitle: queryArg.scanTitle,
                    ProductCode: queryArg.productCode,
                    GarmentType: queryArg.garmentType,
                    From: queryArg["from"],
                    To: queryArg.to,
                    Gender: queryArg.gender,
                    CategoryTags: queryArg.categoryTags,
                    SessionId: queryArg.sessionId,
                    Page: queryArg.page,
                    PageSize: queryArg.pageSize,
                },
            }),
        }),
        sizeMatchControllerRetrieveSizeMatchRecommendationsBulkCsv: build.query<
            SizeMatchControllerRetrieveSizeMatchRecommendationsBulkCsvApiResponse,
            SizeMatchControllerRetrieveSizeMatchRecommendationsBulkCsvApiArg
        >({
            query: (queryArg) => ({
                url: `/size-match/bulk-csv`,
                params: {
                    MerchantId: queryArg.merchantId,
                    ScanTitle: queryArg.scanTitle,
                    ProductCode: queryArg.productCode,
                    GarmentType: queryArg.garmentType,
                    From: queryArg["from"],
                    To: queryArg.to,
                    Gender: queryArg.gender,
                    CategoryTags: queryArg.categoryTags,
                },
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as scanApi };
export type CohortControllerRetrieveCohortsApiResponse =
    /** status 200 OK */ CohortSummaryDtoPagedList;
export type CohortControllerRetrieveCohortsApiArg = {
    merchantId?: number;
    page?: number;
    pageSize?: number;
};
export type CohortControllerCreateCohortApiResponse =
    /** status 200 OK */ CohortDto;
export type CohortControllerCreateCohortApiArg = {
    createCohortCommand: CreateCohortCommand;
};
export type CohortControllerRetrieveCohortApiResponse =
    /** status 200 OK */ CohortDto;
export type CohortControllerRetrieveCohortApiArg = {
    cohortId: number;
    merchantId?: number;
};
export type CohortControllerUpdateCohortApiResponse =
    /** status 200 OK */ CohortDto;
export type CohortControllerUpdateCohortApiArg = {
    cohortId: number;
    updateCohortCommand: UpdateCohortCommand;
};
export type CohortControllerRemoveCohortApiResponse = unknown;
export type CohortControllerRemoveCohortApiArg = {
    cohortId: number;
    merchantId?: number;
};
export type CohortControllerRetrieveCohortMemberApiResponse =
    /** status 200 OK */ CohortMemberDto;
export type CohortControllerRetrieveCohortMemberApiArg = {
    cohortMemberId: number;
    merchantId?: number;
};
export type CohortControllerAddCohortMembersApiResponse =
    /** status 200 OK */ CohortDto;
export type CohortControllerAddCohortMembersApiArg = {
    cohortId: number;
    addCohortMembersCommand: AddCohortMembersCommand;
};
export type CohortControllerRemoveCohortMemberApiResponse = unknown;
export type CohortControllerRemoveCohortMemberApiArg = {
    cohortId: number;
    memberId: number;
    merchantId?: number;
};
export type DevicesControllerCreateFootMeasurementsApiResponse = unknown;
export type DevicesControllerCreateFootMeasurementsApiArg = {
    /** The scan session identifier */
    clientReference: string;
    /** Foot measurements */
    footMeasurements: FootMeasurements;
};
export type MeasurementsControllerRetrieveScanMeasurementsApiResponse =
    /** status 200 OK */ MeasurementCollectionDto;
export type MeasurementsControllerRetrieveScanMeasurementsApiArg = {
    scanId: string;
};
export type MeasurementsControllerRetrieveSessionMeasurementsApiResponse =
    /** status 200 OK */ MeasurementCollectionDto[];
export type MeasurementsControllerRetrieveSessionMeasurementsApiArg = {
    sessionId: number;
};
export type MeasurementsControllerRetrieveMeasurementsCsvApiResponse =
    /** status 200 OK */ string;
export type MeasurementsControllerRetrieveMeasurementsCsvApiArg = {
    sessionId: number;
};
export type MeasurementsControllerRetrieveAllMeasurementsApiResponse =
    /** status 200 OK */ MeasurementCollectionDto;
export type MeasurementsControllerRetrieveAllMeasurementsApiArg = {
    scanId: string;
};
export type MeasurementsControllerRetrieveMeasurementAmendmentsApiResponse =
    /** status 200 OK */ MeasurementAmendmentDto[];
export type MeasurementsControllerRetrieveMeasurementAmendmentsApiArg = {
    scanId: string;
    measurementsId: string;
};
export type MeasurementsControllerUpdateScanMeasurementApiResponse =
    /** status 200 OK */ MeasurementDto;
export type MeasurementsControllerUpdateScanMeasurementApiArg = {
    scanId: string;
    measurementsId: string;
    measurementKey: string;
    measurementAmendmentDto: MeasurementAmendmentDto;
};
export type MeasurementsControllerUpdateWaistMeasurementApiResponse =
    /** status 200 OK */ MeasurementDto;
export type MeasurementsControllerUpdateWaistMeasurementApiArg = {
    scanId: string;
    measurementsId: string;
    waistMeasurementAmendmentDto: WaistMeasurementAmendmentDto;
};
export type ReportsControllerRetrieveScanQualityReportApiResponse = unknown;
export type ReportsControllerRetrieveScanQualityReportApiArg = {
    from?: string;
    to?: string;
    merchantId?: number;
};
export type ReportsControllerRetrieveMeasurementQualityReportApiResponse =
    unknown;
export type ReportsControllerRetrieveMeasurementQualityReportApiArg = {
    from?: string;
    to?: string;
    merchantId?: number;
};
export type ReportsControllerRetrieveSizeMatchAccuracyReportApiResponse =
    unknown;
export type ReportsControllerRetrieveSizeMatchAccuracyReportApiArg = {
    merchantId?: number;
    productCode?: string;
    from?: string;
    to?: string;
};
export type ReportsControllerRetrieveScannerUsageReportApiResponse =
    /** status 200 OK */ ScannerUsageReportWrapperDto;
export type ReportsControllerRetrieveScannerUsageReportApiArg = {
    month?: string;
    merchantId?: number;
};
export type ScanControllerRetrieveScansApiResponse =
    /** status 200 OK */ ScanSummaryPagedList;
export type ScanControllerRetrieveScansApiArg = {
    merchantId?: number;
    page?: number;
    pageSize?: number;
    deviceId?: string;
};
export type ScanControllerRetrieveScanApiResponse =
    /** status 200 OK */ ScanDetailsDto;
export type ScanControllerRetrieveScanApiArg = {
    scanId: string;
};
export type ScanControllerRetrieveWellnessMeasurementsApiResponse =
    /** status 200 OK */ WellnessScanDto;
export type ScanControllerRetrieveWellnessMeasurementsApiArg = {
    scanId: string;
};
export type ScanControllerSubmitQualityReportApiResponse = unknown;
export type ScanControllerSubmitQualityReportApiArg = {
    scanId: string;
    scanQualityReportDto: ScanQualityReportDto;
};
export type ScanControllerRetrieveDownloadUrlApiResponse =
    /** status 200 OK */ DownloadUrl;
export type ScanControllerRetrieveDownloadUrlApiArg = {
    scanId: string;
};
export type ScanControllerRetrieveObjDownloadApiResponse = unknown;
export type ScanControllerRetrieveObjDownloadApiArg = {
    scanId: string;
};
export type ScanControllerRequestIntegrationApiResponse = unknown;
export type ScanControllerRequestIntegrationApiArg = {
    scanId: string;
    integrationDetails?: string;
};
export type ScanControllerRetrieveScanSessionTitleApiResponse =
    /** status 200 OK */ ScanSessionTitleDto;
export type ScanControllerRetrieveScanSessionTitleApiArg = {
    scanId: string;
};
export type SessionsControllerRetrieveSessionsApiResponse =
    /** status 200 OK */ SessionSummaryDtoPagedList;
export type SessionsControllerRetrieveSessionsApiArg = {
    merchantId?: number;
    page?: number;
    deviceId?: string;
    title?: string;
    scanId?: string;
    from?: string;
    to?: string;
    qaPending?: boolean;
    sessionTags?: string;
};
export type SessionsControllerRetrieveSessionApiResponse =
    /** status 200 OK */ SessionDto;
export type SessionsControllerRetrieveSessionApiArg = {
    id: number;
};
export type SessionsControllerRetrieveSessionStatusApiResponse =
    /** status 200 OK */ SessionStatusResultDto;
export type SessionsControllerRetrieveSessionStatusApiArg = {
    id: number;
};
export type SessionsControllerRetrieveDiagnosticsUrlApiResponse =
    /** status 200 OK */ DownloadUrl;
export type SessionsControllerRetrieveDiagnosticsUrlApiArg = {
    id: number;
};
export type SessionsControllerRetrieveAuditHistoryApiResponse =
    /** status 200 OK */ SessionAuditHistoryDtoPagedList;
export type SessionsControllerRetrieveAuditHistoryApiArg = {
    id: number;
    page: number;
};
export type SessionsControllerRetrieveSessionDataByClientReferenceApiResponse =
    /** status 200 OK */ CompleteSessionDataClientDto;
export type SessionsControllerRetrieveSessionDataByClientReferenceApiArg = {
    clientReference: string;
    isInternalRequest?: boolean;
    warnOnSessionNotFound?: boolean;
};
export type SessionsControllerSubscribeSessionApiResponse =
    /** status 200 OK */ SubscribeSessionDto;
export type SessionsControllerSubscribeSessionApiArg = {
    clientReference: string;
    subscribeSessionRequest: SubscribeSessionRequest;
};
export type SessionsControllerRetrieveSessionTagsApiResponse =
    /** status 200 OK */ SessionTagDto[];
export type SessionsControllerRetrieveSessionTagsApiArg = {
    sessionId?: number;
};
export type SessionsControllerUpdateSessionTagsApiResponse = unknown;
export type SessionsControllerUpdateSessionTagsApiArg = {
    sessionId: number;
    body: number[];
};
export type SessionsControllerRetrieveSessionExtractionResultApiResponse =
    /** status 200 OK */ MeasurementExtractionResultDto;
export type SessionsControllerRetrieveSessionExtractionResultApiArg = {
    sessionId: number;
};
export type SessionsControllerRetrieveSessionMeasurementAssetsApiResponse =
    /** status 200 OK */ MeasurementAssetsDto;
export type SessionsControllerRetrieveSessionMeasurementAssetsApiArg = {
    sessionId: number;
};
export type SessionsControllerDeleteSessionApiResponse = unknown;
export type SessionsControllerDeleteSessionApiArg = {
    merchantId: number;
    sessionId: number;
};
export type SizeMatchControllerRetrieveScanSizeMatchRecommendationsApiResponse =
    /** status 200 OK */ SizeMatchRecommendationDtoPagedList;
export type SizeMatchControllerRetrieveScanSizeMatchRecommendationsApiArg = {
    merchantId: number;
    scanId: string;
    productCode?: string;
    page?: number;
    pageSize?: number;
};
export type SizeMatchControllerRetrieveSessionSizeMatchRecommendationsApiResponse =
    /** status 200 OK */ SizeMatchRecommendationDtoPagedList;
export type SizeMatchControllerRetrieveSessionSizeMatchRecommendationsApiArg = {
    merchantId: number;
    sessionId: number;
    productCode?: string;
    page?: number;
    pageSize?: number;
};
export type SizeMatchControllerRetrieveSizeMatchRecommendationsCsvApiResponse =
    /** status 200 OK */ string;
export type SizeMatchControllerRetrieveSizeMatchRecommendationsCsvApiArg = {
    merchantId: number;
    sessionId: number;
    productCode?: string;
    productName?: string;
    fit?: string;
    categoryTags?: string;
};
export type SizeMatchControllerRetrieveProductSizeMatchRecommendationsApiResponse =
    /** status 200 OK */ SizeMatchRecommendationDtoPagedList;
export type SizeMatchControllerRetrieveProductSizeMatchRecommendationsApiArg = {
    merchantId: number;
    productCode: string;
    from?: string;
    pageSize?: number;
};
export type SizeMatchControllerDeleteSizeMatchResultApiResponse =
    /** status 200 OK */ SizeMatchReportDto;
export type SizeMatchControllerDeleteSizeMatchResultApiArg = {
    merchantId: number;
    scanId: string;
    resultId: string;
};
export type SizeMatchControllerAddOrUpdateSizeMatchReportApiResponse =
    /** status 200 OK */ SizeMatchReportDto;
export type SizeMatchControllerAddOrUpdateSizeMatchReportApiArg = {
    merchantId: number;
    scanId: string;
    resultId: string;
    sizeMatchReportDto: SizeMatchReportDto;
};
export type SizeMatchControllerRetrieveSizeMatchRecommendationsApiResponse =
    /** status 200 OK */ SizeMatchRecommendationDtoPagedList;
export type SizeMatchControllerRetrieveSizeMatchRecommendationsApiArg = {
    merchantId?: number;
    scanId?: string;
    scanTitle?: string;
    productCode?: string;
    garmentType?: string;
    from?: string;
    to?: string;
    gender?: string;
    categoryTags?: string;
    sessionId?: number;
    page?: number;
    pageSize?: number;
};
export type SizeMatchControllerRetrieveSizeMatchRecommendationsBulkCsvApiResponse =
    /** status 200 OK */ string;
export type SizeMatchControllerRetrieveSizeMatchRecommendationsBulkCsvApiArg = {
    merchantId?: number;
    scanTitle?: string;
    productCode?: string;
    garmentType?: string;
    from?: string;
    to?: string;
    gender?: string;
    categoryTags?: string;
};
export type CohortSummaryDto = {
    id?: number;
    merchantId?: number;
    name?: string | null;
    isActive?: boolean;
    created?: string;
    memberCount?: number;
    lastScan?: string | null;
};
export type CohortSummaryDtoPagedList = {
    items?: CohortSummaryDto[] | null;
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
};
export type MeasurementCollectionType = "BodyMeasurements" | "BodyComposition";
export type CohortMemberMeasurementDto = {
    id?: number;
    cohortMemberSessionId?: number;
    sessionId?: number;
    measurementKey?: string | null;
    measurementValue?: number;
    collectionType?: MeasurementCollectionType;
};
export type CohortMemberSessionDto = {
    id?: number;
    cohortMemberId?: number;
    sessionId?: number;
    sessionDate?: string;
    measurements?: CohortMemberMeasurementDto[] | null;
};
export type CohortMemberDto = {
    id?: number;
    cohortId?: number;
    identifier?: string | null;
    cohortName?: string | null;
    sessions?: CohortMemberSessionDto[] | null;
};
export type CohortDto = {
    id?: number;
    merchantId?: number;
    name?: string | null;
    isActive?: boolean;
    created?: string;
    members?: CohortMemberDto[] | null;
};
export type CreateCohortCommand = {
    name: string | null;
    merchantId?: number;
};
export type UpdateCohortCommand = {
    cohortId?: number;
    name?: string | null;
    isActive?: boolean | null;
    merchantId?: number;
};
export type AddCohortMembersCommand = {
    cohortId?: number;
    identifiers?: string[] | null;
    merchantId?: number;
};
export type FootMeasurements = {
    measurementMethod?: string | null;
    leftFootLength?: number;
    leftFootStickWidth?: number;
    leftFootTreadWidth?: number;
    leftFootJointGirth?: number;
    rightFootLength?: number;
    rightFootStickWidth?: number;
    rightFootTreadWidth?: number;
    rightFootJointGirth?: number;
};
export type ScanType =
    | "BodyScan"
    | "FootScan"
    | "WellnessScan"
    | "HandScan"
    | "HeadScan"
    | "HealthScan"
    | "MotionScan"
    | "BodyCompositionScan";
export type MeasurementDto = {
    key?: string | null;
    value?: number;
    additional?: number;
    warning?: boolean;
};
export type MeasurementCollectionDto = {
    measurementsId?: string;
    scanType?: ScanType;
    measurements?: MeasurementDto[] | null;
};
export type MeasurementAmendmentDto = {
    measurementKey?: string | null;
    amendedValue?: number;
    oldValue?: number;
    description?: string | null;
    requiresAttention?: boolean;
    measurementsId?: string;
    scanId?: string;
};
export type WaistMeasurementAmendmentDto = {
    description?: string | null;
    requiresAttention?: boolean;
    value?: number;
    level?: number;
};
export type ScannerUsageReportRowDto = {
    deviceId?: string | null;
    scanCount?: number;
};
export type ScannerUsageReportWrapperDto = {
    title?: string | null;
    rows?: ScannerUsageReportRowDto[] | null;
};
export type JsonNodeOptions = {
    propertyNameCaseInsensitive?: boolean;
};
export type JsonNode = {
    options?: JsonNodeOptions;
    parent?: JsonNode;
    root?: JsonNode;
};
export type ScanStatus =
    | "Receiving"
    | "Processing"
    | "Pending"
    | "Available"
    | "Failed"
    | "Deleted";
export type ScanSummary = {
    id?: string;
    deviceId?: string | null;
    merchantId?: number;
    sessionMetadata?: {
        [key: string]: JsonNode;
    } | null;
    scanStatus?: ScanStatus;
    scanType?: ScanType;
    created?: string;
};
export type ScanSummaryPagedList = {
    items?: ScanSummary[] | null;
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
};
export type QualityReportOption =
    | "WearingUpper"
    | "WearingLower"
    | "ScanHoles"
    | "Warping"
    | "HairUntied"
    | "Other"
    | "NoIssues"
    | "WearingLoose"
    | "MeasurementIssue"
    | "NeckIssue";
export type ScanQualityReportDto = {
    options?: QualityReportOption[] | null;
    comments?: string | null;
    qualityCheckComplete?: boolean;
};
export type ScanDetailsDto = {
    id?: string;
    deviceId?: string | null;
    merchantId?: number;
    sessionMetadata?: {
        [key: string]: string;
    } | null;
    scanStatus?: ScanStatus;
    scanType?: ScanType;
    qualityReport?: ScanQualityReportDto;
    qaComplete?: boolean;
    created?: string;
    frontImageUrl?: string | null;
    sideImageUrl?: string | null;
    frontProfileImageUrl?: string | null;
    sideProfileImageUrl?: string | null;
    previewUrl?: string | null;
    hasMeasurements?: boolean;
};
export type Gender = "Male" | "Female" | "Other";
export type WellnessScanDto = {
    gender?: Gender;
    height?: number;
    weight?: number;
    heartRate?: number;
    breathing?: number;
    systolicBP?: number;
    diastolicBP?: number;
    heartRateVariability?: number;
    irregularHeartBeats?: number;
    cardiacWorkload?: number;
    vascularCapacity?: number;
    bmi?: number;
    waistToHeight?: number;
    bodyShape?: number;
    facialAge?: number;
    cardioDiseaseRisk?: number;
    heartAttackRisk?: number;
    strokeRisk?: number;
    hyperTensionRisk?: number;
    diabetesRisk?: number;
    hypercholesterolemiaRisk?: number;
    hypertriglyceridemiaRisk?: number;
    hemoglobinA1cRisk?: number;
    fastingBCRisk?: number;
    vitalScore?: number;
    physicalScore?: number;
    physiologicalScore?: number;
    mentalStressIndex?: number;
    mentalScore?: number;
    risksScore?: number;
    wellnessScore?: number;
    snr?: number;
};
export type DownloadUrl = {
    url?: string | null;
};
export type ScanSessionTitleDto = {
    title?: string | null;
};
export type ActivityStatus = "Busy" | "Ready";
export type SessionSummaryDto = {
    id?: number;
    title?: string | null;
    clientReference?: string | null;
    deviceId?: string | null;
    merchantId?: number;
    activityStatus?: ActivityStatus;
    isCancelled?: boolean;
    scanTypes?: ScanType[] | null;
    created?: string;
};
export type SessionSummaryDtoPagedList = {
    items?: SessionSummaryDto[] | null;
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
};
export type IngressStatus = "Processing" | "Complete";
export type SessionScanDto = {
    id?: string;
    scanType?: ScanType;
    scanStatus?: ScanStatus;
    merchantId?: number;
};
export type BoddRegion = "Unknown" | "AU" | "US" | "USWEST" | "EU" | "UK";
export type SessionTagDto = {
    id?: number;
    label?: string | null;
};
export type SessionDto = {
    assetUrls?: {
        [key: string]: string;
    } | null;
    id?: number;
    title?: string | null;
    clientReference?: string | null;
    deviceId?: string | null;
    appVersion?: string | null;
    fitPreference?: string | null;
    weight?: number;
    isCancelled?: boolean;
    merchantId?: number;
    merchantName?: string | null;
    configurationProfileId?: number;
    configurationProfileName?: string | null;
    activityStatus?: ActivityStatus;
    ingressStatus?: IngressStatus;
    scans?: SessionScanDto[] | null;
    qaCompleted?: boolean;
    qaFeedback?: QualityReportOption[] | null;
    region?: BoddRegion;
    created?: string;
    sessionTags?: SessionTagDto[] | null;
    ingressCompletedAt?: string | null;
    hasExternalSubscription?: boolean;
};
export type ScanStatusItemDto = {
    scanId?: string;
    type?: ScanType;
    status?: ScanStatus;
};
export type SessionStatusResultDto = {
    activityStatus?: ActivityStatus;
    ingressStatus?: IngressStatus;
    scanState?: ScanStatusItemDto[] | null;
    qaFeedback?: QualityReportOption[] | null;
};
export type SessionAuditHistoryDto = {
    id?: number;
    scanId?: string | null;
    action?: string | null;
    payload?: string | null;
    created?: string;
    createdBy?: string | null;
};
export type SessionAuditHistoryDtoPagedList = {
    items?: SessionAuditHistoryDto[] | null;
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
};
export type ScanClientDto = {
    id?: string;
    scanType?: string | null;
    scanStatus?: string | null;
};
export type MeasurementClientDto = {
    key?: string | null;
    value?: number;
};
export type MeasurementCollectionClientDto = {
    measurementsId?: string;
    scanType?: ScanType;
    measurements?: MeasurementClientDto[] | null;
};
export type SizeRecommendationClientDto = {
    merchantId?: number;
    created?: string;
    scanTitle?: string | null;
    productCode?: string | null;
    productName?: string | null;
    fit?: string | null;
    garmentType?: string | null;
    recommendation?: string | null;
    sizeCode?: string | null;
    productMetadata?: {
        [key: string]: string;
    } | null;
};
export type AssetClientDto = {
    bodyFrontImage?: string | null;
    bodySideImage?: string | null;
};
export type CompleteSessionDataClientDto = {
    clientReference?: string | null;
    fitPreference?: string | null;
    merchantId?: number;
    merchantName?: string | null;
    created?: string;
    hasExternalSubscription?: boolean;
    isReady?: boolean;
    scans?: ScanClientDto[] | null;
    measurements?: MeasurementCollectionClientDto[] | null;
    sizeMatchRecommendations?: SizeRecommendationClientDto[] | null;
    assets?: AssetClientDto;
    expiresAt?: string | null;
};
export type SubscribeSessionDto = {
    region?: string | null;
    sessionId?: number;
    isReady?: boolean;
};
export type SubscribeSessionRequest = {
    externalSubscriptionHash?: string | null;
};
export type MeasurementExtractionResultDto = {
    id?: number;
    sessionId?: number;
    legacyMeasurements?: MeasurementDto[] | null;
    boddMeasurements?: MeasurementDto[] | null;
    assetUrls?: string[] | null;
};
export type MeasurementAssetsDto = {
    assetUrls?: string[] | null;
};
export type AlterationDto = {
    dimension?: string | null;
    amount?: number;
    target?: number;
};
export type FitMetadataItem = {
    bodyMeasurement?: number;
    positionInGrade?: number;
    bottomThreshold?: number;
    topThreshold?: number;
};
export type SizeMatchReportType = "DidNotFit" | "Preference";
export type SizeMatchReportDto = {
    sizeMatchResultId?: string;
    description?: string | null;
    dimensionFitMetadata?: {
        [key: string]: FitMetadataItem;
    } | null;
    sizeTaken?: string | null;
    reportType?: SizeMatchReportType;
};
export type SizeMatchRecommendationDto = {
    id?: string;
    scanId?: string;
    merchantId?: number;
    gender?: string | null;
    productCode?: string | null;
    productName?: string | null;
    productMetadata?: {
        [key: string]: string;
    } | null;
    fit?: string | null;
    recommendation?: string | null;
    alterations?: AlterationDto[] | null;
    report?: SizeMatchReportDto;
    fitMetadata?: {
        [key: string]: FitMetadataItem;
    } | null;
    created?: string;
    scanTitle?: string | null;
    productCategoryTags?: string[] | null;
    garmentType?: string | null;
    scanSessionId?: number;
    sizeCode?: string | null;
};
export type SizeMatchRecommendationDtoPagedList = {
    items?: SizeMatchRecommendationDto[] | null;
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
};
export const {
    useCohortControllerRetrieveCohortsQuery,
    useCohortControllerCreateCohortMutation,
    useCohortControllerRetrieveCohortQuery,
    useCohortControllerUpdateCohortMutation,
    useCohortControllerRemoveCohortMutation,
    useCohortControllerRetrieveCohortMemberQuery,
    useCohortControllerAddCohortMembersMutation,
    useCohortControllerRemoveCohortMemberMutation,
    useDevicesControllerCreateFootMeasurementsMutation,
    useMeasurementsControllerRetrieveScanMeasurementsQuery,
    useMeasurementsControllerRetrieveSessionMeasurementsQuery,
    useMeasurementsControllerRetrieveMeasurementsCsvQuery,
    useMeasurementsControllerRetrieveAllMeasurementsQuery,
    useMeasurementsControllerRetrieveMeasurementAmendmentsQuery,
    useMeasurementsControllerUpdateScanMeasurementMutation,
    useMeasurementsControllerUpdateWaistMeasurementMutation,
    useReportsControllerRetrieveScanQualityReportQuery,
    useReportsControllerRetrieveMeasurementQualityReportQuery,
    useReportsControllerRetrieveSizeMatchAccuracyReportQuery,
    useReportsControllerRetrieveScannerUsageReportQuery,
    useScanControllerRetrieveScansQuery,
    useScanControllerRetrieveScanQuery,
    useScanControllerRetrieveWellnessMeasurementsQuery,
    useScanControllerSubmitQualityReportMutation,
    useScanControllerRetrieveDownloadUrlQuery,
    useScanControllerRetrieveObjDownloadQuery,
    useScanControllerRequestIntegrationMutation,
    useScanControllerRetrieveScanSessionTitleQuery,
    useSessionsControllerRetrieveSessionsQuery,
    useSessionsControllerRetrieveSessionQuery,
    useSessionsControllerRetrieveSessionStatusQuery,
    useSessionsControllerRetrieveDiagnosticsUrlQuery,
    useSessionsControllerRetrieveAuditHistoryQuery,
    useSessionsControllerRetrieveSessionDataByClientReferenceQuery,
    useSessionsControllerSubscribeSessionMutation,
    useSessionsControllerRetrieveSessionTagsQuery,
    useSessionsControllerUpdateSessionTagsMutation,
    useSessionsControllerRetrieveSessionExtractionResultQuery,
    useSessionsControllerRetrieveSessionMeasurementAssetsQuery,
    useSessionsControllerDeleteSessionMutation,
    useSizeMatchControllerRetrieveScanSizeMatchRecommendationsQuery,
    useSizeMatchControllerRetrieveSessionSizeMatchRecommendationsQuery,
    useSizeMatchControllerRetrieveSizeMatchRecommendationsCsvQuery,
    useSizeMatchControllerRetrieveProductSizeMatchRecommendationsQuery,
    useSizeMatchControllerDeleteSizeMatchResultMutation,
    useSizeMatchControllerAddOrUpdateSizeMatchReportMutation,
    useSizeMatchControllerRetrieveSizeMatchRecommendationsQuery,
    useSizeMatchControllerRetrieveSizeMatchRecommendationsBulkCsvQuery,
} = injectedRtkApi;
